import React from "react";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { itx } from "../translationItx/itx";

export default function OnBoardingWindowHost(props: { style?: any }) {
  var { style } = props;
  useOnChangeWatcher(state?.onBoadingManager);

  if (!state) {
    return <div>{itx("dialogHost.noStateAvailible", "No State availible yet")}</div>;
  }

  if (!state.onBoadingManager.isOpen) {
    return <div style={{ display: "none" }} className="nonModalOnBoardingWrapper"></div>;
  }

  let cls = "nonModalOnBoardingWrapper"; // no itx

  if (!style) {
    style = {};
  }
  style.left = "200px"; // no itx
  style.top = "200px"; // no itx

  return (
    <div
      id="nonModalOnBoardingWrapper"
      className={cls + " App"} // no itx
      style={style}
      onClick={(event: any) => {
        if (event.target.id === "nonModalOnBoardingWrapper") {
          state.onBoadingManager.closeWindow();
        }
      }}
    >
      {state.onBoadingManager.currentWindow}
    </div>
  );
}
